import React, { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./styles";

type Props = {
  pendingCount: number;
  text: string;
  onClick?: VoidFunction;
}

const SupplementaryInfo: FC<Props> = ({ pendingCount, text, onClick }) => {
  const classes = useStyles({ pendingCount });

  const isLink = pendingCount && onClick;

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      className={`${classes.opacity} ${isLink ? classes.link : ""}`}
      onClick={isLink ? onClick : undefined}
    >
      <Box className={classes.oval} display="inline-flex" />
      <Typography
        component="span"
        className={classes.text}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default SupplementaryInfo;
